import React from 'react';
import CreditNotePurchaseInvoice from '../../components/PurchaseInvoiceCreation/CreditNote/CreditNotePurchaseInvoice';

const CreditNotePurchaseInvoicePage: React.FC = () => {
  return (
    <div>
      <CreditNotePurchaseInvoice />
    </div>
  );
};

export default CreditNotePurchaseInvoicePage;
